import React, { createContext, useState } from 'react'
import { AiFillPropertySafety } from 'react-icons/ai';
import axios from "axios";
import { toast } from 'react-toastify';

export const LoginSingupPageContext =createContext();

const LoginSingupPageContextProvider=(props)=>{
    const [pageState,setPageState]=useState("login");

   
    

    return(
        <LoginSingupPageContext.Provider value={{pageState,setPageState}}>
            {props.children}
        </LoginSingupPageContext.Provider>
    )
}

export default LoginSingupPageContextProvider
